import { useTranslation } from 'react-i18next';

import { ROLES, VIEWS_NAMES } from './constants';

export function useRoles() {
	const { t } = useTranslation();
	return {
		[ROLES.admin]: t('users.roles.admin'),
		[ROLES.extendedCollaborator]: t('users.roles.collaborator'),
		[ROLES.collaborator]: t('users.roles.limited')
	};
}

export function useViews() {
	const { t } = useTranslation();
	return [
		{
			value: VIEWS_NAMES.EDITOR,
			label: t('users.views.editor')
		},
		{
			value: VIEWS_NAMES.MY_PDFS,
			label: t('users.views.myPdfs')
		},
		{
			value: VIEWS_NAMES.BILLING,
			label: t('users.views.billing')
		},
		{
			value: VIEWS_NAMES.TAX_INFO,
			label: t('users.views.taxInfo')
		}
	];
}
